<div
  class="flex flex-col gap-4 custom-form"
  [class.analytics-planned-mode]="isAnalyticsPlannedMode()"
  [class.custom-form-readonly]="isAnalyticsPlannedMode()"
>
  @for (group of groupedDeliverables(); track trackByDeliverableGroup($index, group)) {
    <div class="flex flex-col">
      <div class="flex flex-col gap-2">
        @for (item of group.deliverables; track trackByDeliverable($index, item); let first = $first) {
          <div
            class="transition-colors duration-300 rounded-lg -mx-3 px-3 -my-1 py-1"
            [class.bg-shikenso-pink-base-12]="isNewlyAddedDeliverable(item.control.get('id')?.value ?? '')"
            [attr.data-element-id]="item.control.get('id')?.value"
          >
            @switch (group.type) {
              @case (EDeliverableType.title) {
                <app-title
                  [form]="item.control"
                  [platformFeature]="platformFeature()"
                  [isLabelVisible]="group.config.hasLabel && first"
                  [creatorId]="creatorId()"
                  [ctaTemplateId]="ctaTemplateId()"
                  [isCustomMode]="isCustomMode()"
                  [isParentDeleteDisabled]="isParentDeleteDisabled()"
                  [lastActiveElementDetails]="lastActiveElementDetails()"
                  [creators]="creators()"
                  [isExpanded]="isAllExpanded()"
                  [isViewMode]="isViewMode()"
                  [creatorBriefingMode]="creatorBriefingMode()"
                  [showRequiredBadge]="isAnalyticsPlannedMode()"
                  [showStatusBadge]="showStatusBadge()"
                  (delete)="removeDeliverable(item.control.get('id')?.value ?? '')"
                  (parentCheckboxChange)="checkParentDeleteDisabled()"
                />
              }
              @case (EDeliverableType.gamePlay) {
                <app-game-play
                  [form]="item.control"
                  [platformFeature]="platformFeature()"
                  [executionValues]="executionValues()"
                  [creatorId]="creatorId()"
                  [ctaTemplateId]="ctaTemplateId()"
                  [isCustomMode]="isCustomMode()"
                  [isParentDeleteDisabled]="isParentDeleteDisabled()"
                  [lastActiveElementDetails]="lastActiveElementDetails()"
                  [creators]="creators()"
                  [isExpanded]="isAllExpanded()"
                  [isViewMode]="isViewMode()"
                  [creatorBriefingMode]="creatorBriefingMode()"
                  [showRequiredBadge]="isAnalyticsPlannedMode()"
                  [showStatusBadge]="showStatusBadge()"
                  (delete)="removeDeliverable(item.control.get('id')?.value ?? '')"
                  (parentCheckboxChange)="checkParentDeleteDisabled()"
                />
              }
              @case (EDeliverableType.chatBot) {
                <app-chatbot
                  [form]="item.control"
                  [platformFeature]="platformFeature()"
                  [creatorId]="creatorId()"
                  [ctaTemplateId]="ctaTemplateId()"
                  [isCustomMode]="isCustomMode()"
                  [isParentDeleteDisabled]="isParentDeleteDisabled()"
                  [lastActiveElementDetails]="lastActiveElementDetails()"
                  [creators]="creators()"
                  [isExpanded]="isAllExpanded()"
                  [isViewMode]="isViewMode()"
                  [creatorBriefingMode]="creatorBriefingMode()"
                  [showRequiredBadge]="isAnalyticsPlannedMode()"
                  [showStatusBadge]="showStatusBadge()"
                  (delete)="removeDeliverable(item.control.get('id')?.value ?? '')"
                  (parentCheckboxChange)="checkParentDeleteDisabled()"
                />
              }
              @case (EDeliverableType.chatbotMulti) {
                <app-chatbot-multi
                  [form]="item.control"
                  [platformFeature]="platformFeature()"
                  [creatorId]="creatorId()"
                  [ctaTemplateId]="ctaTemplateId()"
                  [isCustomMode]="isCustomMode()"
                  [isParentDeleteDisabled]="isParentDeleteDisabled()"
                  [lastActiveElementDetails]="lastActiveElementDetails()"
                  [creators]="creators()"
                  [isExpanded]="isAllExpanded()"
                  [isViewMode]="isViewMode()"
                  [creatorBriefingMode]="creatorBriefingMode()"
                  [showRequiredBadge]="isAnalyticsPlannedMode()"
                  [showStatusBadge]="showStatusBadge()"
                  (delete)="removeDeliverable(item.control.get('id')?.value ?? '')"
                  (parentCheckboxChange)="checkParentDeleteDisabled()"
                />
              }
              @case (EDeliverableType.talkingPoint) {
                <app-talking-point
                  [form]="item.control"
                  [platformFeature]="platformFeature()"
                  [isLabelVisible]="group.config.hasLabel && first"
                  [creatorId]="creatorId()"
                  [ctaTemplateId]="ctaTemplateId()"
                  [isCustomMode]="isCustomMode()"
                  [isParentDeleteDisabled]="isParentDeleteDisabled()"
                  [lastActiveElementDetails]="lastActiveElementDetails()"
                  [creators]="creators()"
                  [isExpanded]="isAllExpanded()"
                  [isViewMode]="isViewMode()"
                  [creatorBriefingMode]="creatorBriefingMode()"
                  [showRequiredBadge]="isAnalyticsPlannedMode()"
                  [showStatusBadge]="showStatusBadge()"
                  (delete)="removeDeliverable(item.control.get('id')?.value ?? '')"
                  (parentCheckboxChange)="checkParentDeleteDisabled()"
                />
              }
              @case (EDeliverableType.talkingPointAi) {
                <app-talking-point-ai
                  [form]="item.control"
                  [platformFeature]="platformFeature()"
                  [creatorId]="creatorId()"
                  [ctaTemplateId]="ctaTemplateId()"
                  [isCustomMode]="isCustomMode()"
                  [isParentDeleteDisabled]="isParentDeleteDisabled()"
                  [lastActiveElementDetails]="lastActiveElementDetails()"
                  [creators]="creators()"
                  [isExpanded]="isAllExpanded()"
                  [isViewMode]="isViewMode()"
                  [creatorBriefingMode]="creatorBriefingMode()"
                  [showRequiredBadge]="isAnalyticsPlannedMode()"
                  [showStatusBadge]="showStatusBadge()"
                  (delete)="removeDeliverable(item.control.get('id')?.value ?? '')"
                  (parentCheckboxChange)="checkParentDeleteDisabled()"
                />
              }
              @case (EDeliverableType.visual) {
                <app-visual
                  [form]="item.control"
                  [platformFeature]="platformFeature()"
                  [creatorId]="creatorId()"
                  [ctaTemplateId]="ctaTemplateId()"
                  [isCustomMode]="isCustomMode()"
                  [isParentDeleteDisabled]="isParentDeleteDisabled()"
                  [lastActiveElementDetails]="lastActiveElementDetails()"
                  [creators]="creators()"
                  [isExpanded]="isAllExpanded()"
                  [isViewMode]="isViewMode()"
                  [creatorBriefingMode]="creatorBriefingMode()"
                  [showRequiredBadge]="isAnalyticsPlannedMode()"
                  [showStatusBadge]="showStatusBadge()"
                  (delete)="removeDeliverable(item.control.get('id')?.value ?? '')"
                  (parentCheckboxChange)="checkParentDeleteDisabled()"
                />
              }
              @case (EDeliverableType.productPlacement) {
                <app-product-placement
                  [form]="item.control"
                  [platformFeature]="platformFeature()"
                  [isLabelVisible]="group.config.hasLabel && first"
                  [creatorId]="creatorId()"
                  [ctaTemplateId]="ctaTemplateId()"
                  [isCustomMode]="isCustomMode()"
                  [isParentDeleteDisabled]="isParentDeleteDisabled()"
                  [lastActiveElementDetails]="lastActiveElementDetails()"
                  [creators]="creators()"
                  [isExpanded]="isAllExpanded()"
                  [isViewMode]="isViewMode()"
                  [creatorBriefingMode]="creatorBriefingMode()"
                  [showRequiredBadge]="isAnalyticsPlannedMode()"
                  [showStatusBadge]="showStatusBadge()"
                  (delete)="removeDeliverable(item.control.get('id')?.value ?? '')"
                  (parentCheckboxChange)="checkParentDeleteDisabled()"
                />
              }
              @case (EDeliverableType.showcase) {
                <app-showcase
                  [form]="item.control"
                  [platformFeature]="platformFeature()"
                  [creatorId]="creatorId()"
                  [ctaTemplateId]="ctaTemplateId()"
                  [isCustomMode]="isCustomMode()"
                  [isParentDeleteDisabled]="isParentDeleteDisabled()"
                  [lastActiveElementDetails]="lastActiveElementDetails()"
                  [creators]="creators()"
                  [isChildOptional]="group.config.isChildOptional || false"
                  [isExpanded]="isAllExpanded()"
                  [isViewMode]="isViewMode()"
                  [creatorBriefingMode]="creatorBriefingMode()"
                  [showRequiredBadge]="isAnalyticsPlannedMode()"
                  [showStatusBadge]="showStatusBadge()"
                  (delete)="removeDeliverable(item.control.get('id')?.value ?? '')"
                  (parentCheckboxChange)="checkParentDeleteDisabled()"
                />
              }
              @case (EDeliverableType.custom) {
                <app-custom
                  [form]="item.control"
                  [platformFeature]="platformFeature()"
                  [creatorId]="creatorId()"
                  [ctaTemplateId]="ctaTemplateId()"
                  [isCustomMode]="isCustomMode()"
                  [isParentDeleteDisabled]="isParentDeleteDisabled()"
                  [lastActiveElementDetails]="lastActiveElementDetails()"
                  [creators]="creators()"
                  [isChildOptional]="group.config.isChildOptional || false"
                  [isExpanded]="isAllExpanded()"
                  [isViewMode]="isViewMode()"
                  [creatorBriefingMode]="creatorBriefingMode()"
                  [showRequiredBadge]="isAnalyticsPlannedMode()"
                  [showStatusBadge]="showStatusBadge()"
                  (delete)="removeDeliverable(item.control.get('id')?.value ?? '')"
                  (parentCheckboxChange)="checkParentDeleteDisabled()"
                />
              }
              @case (EDeliverableType.content) {
                <app-content
                  [form]="item.control"
                  [platformFeature]="platformFeature()"
                  [creatorId]="creatorId()"
                  [ctaTemplateId]="ctaTemplateId()"
                  [isCustomMode]="isCustomMode()"
                  [isParentDeleteDisabled]="isParentDeleteDisabled()"
                  [lastActiveElementDetails]="lastActiveElementDetails()"
                  [creators]="creators()"
                  [isChildOptional]="group.config.isChildOptional || false"
                  [isExpanded]="isAllExpanded()"
                  [isViewMode]="isViewMode()"
                  [creatorBriefingMode]="creatorBriefingMode()"
                  [showRequiredBadge]="isAnalyticsPlannedMode()"
                  [showStatusBadge]="showStatusBadge()"
                  (delete)="removeDeliverable(item.control.get('id')?.value ?? '')"
                  (parentCheckboxChange)="checkParentDeleteDisabled()"
                />
              }
              @case (EDeliverableType.textTracking) {
                <app-text-tracking
                  [form]="item.control"
                  [platformFeature]="platformFeature()"
                  [isLabelVisible]="group.config.hasLabel && first"
                  [creatorId]="creatorId()"
                  [ctaTemplateId]="ctaTemplateId()"
                  [isCustomMode]="isCustomMode()"
                  [isParentDeleteDisabled]="isParentDeleteDisabled()"
                  [lastActiveElementDetails]="lastActiveElementDetails()"
                  [creators]="creators()"
                  [isExpanded]="isAllExpanded()"
                  [isGlobalTracking]="isGlobalTracking()"
                  [isViewMode]="isViewMode()"
                  [creatorBriefingMode]="creatorBriefingMode()"
                  [showRequiredBadge]="isAnalyticsPlannedMode()"
                  [showStatusBadge]="showStatusBadge()"
                  (delete)="removeDeliverable(item.control.get('id')?.value ?? '')"
                  (parentCheckboxChange)="checkParentDeleteDisabled()"
                />
              }
              @case (EDeliverableType.audioTracking) {
                <app-audio-tracking
                  [form]="item.control"
                  [platformFeature]="platformFeature()"
                  [isLabelVisible]="group.config.hasLabel && first"
                  [creatorId]="creatorId()"
                  [ctaTemplateId]="ctaTemplateId()"
                  [isCustomMode]="isCustomMode()"
                  [isParentDeleteDisabled]="isParentDeleteDisabled()"
                  [lastActiveElementDetails]="lastActiveElementDetails()"
                  [creators]="creators()"
                  [isExpanded]="isAllExpanded()"
                  [isGlobalTracking]="isGlobalTracking()"
                  [isViewMode]="isViewMode()"
                  [creatorBriefingMode]="creatorBriefingMode()"
                  [showRequiredBadge]="isAnalyticsPlannedMode()"
                  [showStatusBadge]="showStatusBadge()"
                  (delete)="removeDeliverable(item.control.get('id')?.value ?? '')"
                  (parentCheckboxChange)="checkParentDeleteDisabled()"
                />
              }
              @case (EDeliverableType.caption) {
                <app-caption
                  [form]="item.control"
                  [platformFeature]="platformFeature()"
                  [isLabelVisible]="group.config.hasLabel && first"
                  [creatorId]="creatorId()"
                  [ctaTemplateId]="ctaTemplateId()"
                  [isCustomMode]="isCustomMode()"
                  [isParentDeleteDisabled]="isParentDeleteDisabled()"
                  [lastActiveElementDetails]="lastActiveElementDetails()"
                  [creators]="creators()"
                  [isExpanded]="isAllExpanded()"
                  [isViewMode]="isViewMode()"
                  [creatorBriefingMode]="creatorBriefingMode()"
                  [showRequiredBadge]="isAnalyticsPlannedMode()"
                  [showStatusBadge]="showStatusBadge()"
                  (delete)="removeDeliverable(item.control.get('id')?.value ?? '')"
                  (parentCheckboxChange)="checkParentDeleteDisabled()"
                />
              }
              @case (EDeliverableType.hashTag) {
                <app-hashtag
                  [form]="item.control"
                  [platformFeature]="platformFeature()"
                  [isLabelVisible]="group.config.hasLabel && first"
                  [creatorId]="creatorId()"
                  [ctaTemplateId]="ctaTemplateId()"
                  [isCustomMode]="isCustomMode()"
                  [isParentDeleteDisabled]="isParentDeleteDisabled()"
                  [lastActiveElementDetails]="lastActiveElementDetails()"
                  [creators]="creators()"
                  [isExpanded]="isAllExpanded()"
                  [isViewMode]="isViewMode()"
                  [creatorBriefingMode]="creatorBriefingMode()"
                  [showRequiredBadge]="isAnalyticsPlannedMode()"
                  [showStatusBadge]="showStatusBadge()"
                  (delete)="removeDeliverable(item.control.get('id')?.value ?? '')"
                  (parentCheckboxChange)="checkParentDeleteDisabled()"
                />
              }
              @case (EDeliverableType.mention) {
                <app-mention
                  [form]="item.control"
                  [platformFeature]="platformFeature()"
                  [isLabelVisible]="group.config.hasLabel && first"
                  [creatorId]="creatorId()"
                  [ctaTemplateId]="ctaTemplateId()"
                  [isCustomMode]="isCustomMode()"
                  [isParentDeleteDisabled]="isParentDeleteDisabled()"
                  [lastActiveElementDetails]="lastActiveElementDetails()"
                  [creators]="creators()"
                  [isExpanded]="isAllExpanded()"
                  [isViewMode]="isViewMode()"
                  [creatorBriefingMode]="creatorBriefingMode()"
                  [showRequiredBadge]="isAnalyticsPlannedMode()"
                  [showStatusBadge]="showStatusBadge()"
                  (delete)="removeDeliverable(item.control.get('id')?.value ?? '')"
                  (parentCheckboxChange)="checkParentDeleteDisabled()"
                />
              }
              @case (EDeliverableType.message) {
                <app-message
                  [form]="item.control"
                  [platformFeature]="platformFeature()"
                  [isLabelVisible]="group.config.hasLabel && first"
                  [creatorId]="creatorId()"
                  [ctaTemplateId]="ctaTemplateId()"
                  [isCustomMode]="isCustomMode()"
                  [isParentDeleteDisabled]="isParentDeleteDisabled()"
                  [lastActiveElementDetails]="lastActiveElementDetails()"
                  [creators]="creators()"
                  [isExpanded]="isAllExpanded()"
                  [isViewMode]="isViewMode()"
                  [creatorBriefingMode]="creatorBriefingMode()"
                  [showRequiredBadge]="isAnalyticsPlannedMode()"
                  [showStatusBadge]="showStatusBadge()"
                  (delete)="removeDeliverable(item.control.get('id')?.value ?? '')"
                  (parentCheckboxChange)="checkParentDeleteDisabled()"
                />
              }
              @case (EDeliverableType.description) {
                <app-description
                  [form]="item.control"
                  [platformFeature]="platformFeature()"
                  [isLabelVisible]="group.config.hasLabel && first"
                  [creatorId]="creatorId()"
                  [ctaTemplateId]="ctaTemplateId()"
                  [isCustomMode]="isCustomMode()"
                  [isParentDeleteDisabled]="isParentDeleteDisabled()"
                  [lastActiveElementDetails]="lastActiveElementDetails()"
                  [creators]="creators()"
                  [isExpanded]="isAllExpanded()"
                  [isViewMode]="isViewMode()"
                  [creatorBriefingMode]="creatorBriefingMode()"
                  [showRequiredBadge]="isAnalyticsPlannedMode()"
                  [showStatusBadge]="showStatusBadge()"
                  (delete)="removeDeliverable(item.control.get('id')?.value ?? '')"
                  (parentCheckboxChange)="checkParentDeleteDisabled()"
                />
              }
            }
          </div>
        }
      </div>
    </div>
  }

  @if (!isViewMode()) {
    <div class="flex justify-center items-center w-fu;;">
      @let disabled = (!displayDeliverableConfigs()?.length || !ctaForm()?.get('name')?.value) && !isGlobalTracking();

      <div
        class="w-full"
        matTooltipPosition="above"
        [matTooltip]="
          disabled
            ? ctaForm()
              ? ('pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.noName' | translate)
              : ('pages.campaignForm.ctaDialog.ctaDetails.hasNoActiveDeliverables'
                | translate: { platformFeature: 'shared.platformFeatures.' + platformFeature() | translate })
            : ''
        "
      >
        <button
          mat-flat-button
          type="button"
          class="w-full mat-thick-button"
          color="secondary-gray-border"
          [matMenuTriggerFor]="menu"
          [disabled]="disabled"
        >
          <div class="flex items-center gap-1">
            <app-icon src="/icons/plus.svg" alt="add" class="w-5 h-5 self-center" />

            @if (isGlobalTracking()) {
              {{ 'pages.campaignForm.sections.keywordTracking.addTracking' | translate }}
            } @else {
              {{ 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.addDeliverable' | translate }}
            }
          </div>
        </button>
      </div>
    </div>
  }

  <mat-menu #menu="matMenu" class="!w-xl !max-w-xl">
    @for (
      topLevelGroup of groupedMenuDeliverableConfigs();
      track trackByMenuTopLevelGroup($index, topLevelGroup);
      let firstTopLevel = $first
    ) {
      <div
        class="flex items-center gap-1.5 pl-3 pt-3 pb-1"
        [class.mt-1]="!firstTopLevel"
        [class.border-t]="!firstTopLevel"
        [class.border-shikenso-purple-base-12]="!firstTopLevel"
      >
        <span class="text-xs font-bold text-shikenso-purple-base">
          {{
            (topLevelGroup.isCheckedManually
              ? 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.manuallyChecked'
              : 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.automaticallyChecked'
            ) | translate
          }}
        </span>
        <app-icon
          src="/icons/info-circle.svg"
          alt="info"
          matTooltipPosition="right"
          class="text-shikenso-purple-base-40 flex-shrink-0"
          [size]="14"
          [matTooltip]="
            (topLevelGroup.isCheckedManually
              ? 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.manuallyCheckedTooltip'
              : 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.automaticallyCheckedTooltip'
            ) | translate
          "
        />
      </div>

      @for (categoryGroup of topLevelGroup.categoryGroups; track categoryGroup.category; let firstCategory = $first) {
        <div
          class="pl-7 pb-0 text-shikenso-purple-base-40 text-xs font-bold"
          [class.pt-2]="firstCategory"
          [class.pt-3]="!firstCategory"
        >
          {{ getCategoryLabel(categoryGroup.category) }}
        </div>

        @for (config of categoryGroup.configs; track config.id) {
          <button mat-menu-item class="!h-auto !min-h-0 !py-2 !pl-12" (click)="addDeliverable(config.type)">
            <div class="flex flex-col items-start gap-1 text-left">
              <span class="text-sm">
                {{ 'shared.deliverableTypes.' + config.type | translate }}
              </span>
              <span class="text-xs text-shikenso-purple-base-60 whitespace-normal">
                {{
                  'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.deliverableStep.deliverableDescriptions.' +
                    config.type | translate
                }}
              </span>
            </div>
          </button>
        }
      }
    }
  </mat-menu>
</div>
